import { render, staticRenderFns } from "./mobile-register-entrance.vue?vue&type=template&id=8274f068&scoped=true&"
import script from "./mobile-register-entrance.vue?vue&type=script&lang=js&"
export * from "./mobile-register-entrance.vue?vue&type=script&lang=js&"
import style0 from "./mobile-register-entrance.vue?vue&type=style&index=0&id=8274f068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8274f068",
  null
  
)

export default component.exports